import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "emailField", "commentField"]

  connect() {
    // Initialize the dialog as closed
    if (this.hasDialogTarget) {
      this.dialogTarget.addEventListener("close", () => {
        this.resetForm()
      })
    }
  }

  open() {
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
      document.body.style.overflow = "hidden"
      
      // Focus on comment field when opened
      if (this.hasCommentFieldTarget) {
        setTimeout(() => {
          this.commentFieldTarget.focus()
        }, 100)
      }
    }
  }

  close() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close()
      document.body.style.overflow = ""
      this.resetForm()
    }
  }

  backdropClose(event) {
    // Close dialog when clicking on backdrop
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  async submit(event) {
    event.preventDefault()

    const formData = new FormData(this.formTarget)
    const submitButton = event.submitter || this.formTarget.querySelector('button[type="submit"]')
    const originalText = submitButton?.textContent

    // Disable submit button
    if (submitButton) {
      submitButton.disabled = true
      submitButton.textContent = "Submitting..."
    }

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (data.success) {
        // Show success message
        this.showMessage(data.message, "success")
        setTimeout(() => {
          this.close()
        }, 2000)
      } else {
        // Show error message
        this.showMessage(data.errors?.join(", ") || "Failed to submit feedback", "error")
        if (submitButton) {
          submitButton.disabled = false
          submitButton.textContent = originalText
        }
      }
    } catch (error) {
      console.error("Error submitting feedback:", error)
      this.showMessage("An error occurred. Please try again.", "error")
      if (submitButton) {
        submitButton.disabled = false
        submitButton.textContent = originalText
      }
    }
  }

  showMessage(message, type) {
    // Remove existing message if any
    const existingMessage = this.dialogTarget.querySelector(".feedback-message")
    if (existingMessage) {
      existingMessage.remove()
    }

    // Create message element
    const messageDiv = document.createElement("div")
    messageDiv.className = `feedback-message p-3 rounded-md mb-4 ${
      type === "success" 
        ? "bg-green-900/20 border border-green-600 text-green-400" 
        : "bg-red-900/20 border border-red-600 text-red-400"
    }`
    messageDiv.textContent = message

    // Insert before form
    this.formTarget.parentNode.insertBefore(messageDiv, this.formTarget)
  }

  resetForm() {
    if (this.hasFormTarget) {
      this.formTarget.reset()
    }
    
    // Remove any messages
    const message = this.dialogTarget?.querySelector(".feedback-message")
    if (message) {
      message.remove()
    }
  }
}
